import { clampFillOpacity } from './fillOpacity';
import { BackdropImageType } from '../types/floorplannerTypes';

/** Matches the historical hardcoded mesh opacity for background images. */
export const DEFAULT_BACKDROP_OPACITY = 0.8;

/**
 * Whether a background image should be drawn. Missing `visible` means shown
 * so older floorplans keep their previous behavior.
 */
export const isBackdropVisible = (symbol: BackdropImageType): boolean =>
  symbol.visible !== false;

/**
 * Locked or hidden background images must not steal canvas clicks so floor
 * fills and other objects remain reachable underneath.
 */
export const isBackdropSelectableOnCanvas = (symbol: BackdropImageType): boolean =>
  isBackdropVisible(symbol) && !symbol.locked;

/**
 * Resolve stored opacity for rendering / UI, defaulting to the legacy 0.8.
 */
export const resolveBackdropOpacity = (symbol: BackdropImageType): number =>
  clampFillOpacity(symbol.opacity, DEFAULT_BACKDROP_OPACITY);
